export function useBaseUrl(): string {
  const baseUrl = process.env['REACT_APP_PHOTOBOOK_API_BASE_URL'];
  return baseUrl || 'http://localhost:8080/photobook';
}

export const useExperimentsBaseUrl = () => {
  const baseUrl = process.env['REACT_APP_CONSUMER_EXPERIMENTS_BASE_URL'];
  return baseUrl || 'https://stratus-pie.tropos-rnd.com/cse-backend';
};

export const usePhotoCuratorBaseUrl = () => {
  const baseUrl = process.env['REACT_APP_PHOTO_CURATOR_BASE_URL'];
  return baseUrl || 'http://localhost:8080/photobook-curator';
};

export const usePhotoCuratorUrl = () => {
  return usePhotoCuratorBaseUrl() + '/index.html?resume=review';
};

export const useMediaclipKeepAliveUrl = () => {
  return useBaseUrl() + '/api/v2/client/mediaclip/public/renewToken';
};
